<template>
  <div>
    <v-container class="fluid-max-width pa-0" v-if="currentShaft">
      <v-breadcrumbs :items="breadcrumbItems">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
      <ShaftListItem
        :item="currentShaft"
        showAvatar="true"
        @duplicateClick="onDuplicateClicked"
        @deleteClick="onDeleteClicked"
      />
      <v-tabs
        v-model="tab"
        @change="onTabChange"
        background-color="transparent"
        color="primary"
        grow
        class="shaft-tabs pa-4"
      >
        <v-tab>Schachtboden</v-tab>
        <v-tab>Schachtaufbau</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="pa-4">
        <v-tab-item>
          <v-card tile :elevation="0" outlined>
            <div
              class="d-flex flex-column align-center justify-center shaft-image"
            >
              <router-link
                router-link
                :to="`/schacht/${currentShaft.id}/boden`"
                v-if="currentShaft && currentShaft.type"
              >
                <ShaftImage
                  ref="shaftImage"
                  :shaft="currentShaft"
                  :showLabels="true"
                  width="350px"
                  height="350px"
                />
              </router-link>
              <h4 v-else>Kein Schachtboden</h4>
            </div>
            <v-card-actions class="grey lighten-3">
              <v-btn text :to="`/schacht/${currentShaft.id}/boden`">
                <v-icon color="primary" class="mr-2">{{
                  shaftBaseEditIcon
                }}</v-icon>
                {{ shaftBaseEditLabel }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                icon
                :disabled="!hasBase || currentShaft.ordered"
                @click="onResetShaftBaseClicked(currentShaft)"
              >
                <v-icon> mdi-delete</v-icon>
              </v-btn>
              <DialogConfirm
                ref="deleteBaseDialog"
                caption="Schachtboden wirklich"
                title="löschen?"
                message="Diese Aktion kann nicht mehr rückgängig gemacht werden."
                ok="Ja, löschen"
                cancel="Nein"
              />
            </v-card-actions>
          </v-card>
          <v-container
            class="mt-4 d-flex flex-column align-center justify-center"
          >
            <v-row class="ma-0 pa-0">
              <v-col
                class="d-flex flex-column justify-center align-center"
                cols="12"
              >
                <v-btn
                  depressed
                  color="primary"
                  outlined
                  width="200"
                  v-if="!currentShaft.ordered"
                  :disabled="!canSubmit"
                  @click="onOrderShaftClicked"
                  :loading="isOrdering"
                >
                  <v-icon left> mdi-cart-arrow-down</v-icon>
                  Schacht bestellen
                </v-btn>
                <p class="ma-2" v-if="currentShaft.ordered">
                  <v-icon class="mr-1">
                    mdi-cart-check
                  </v-icon>
                  Bestellt am {{ orderDate }}
                </p>
                <router-link
                  :to="`/baustellen/` + currentShaft.site_id.id"
                  depressed
                  color="primary"
                  outlined
                  width="200"
                  class="mt-4"
                >
                  zur Baustellenübersicht
                </router-link>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-card tile :elevation="0" outlined class="text-center">
            <div
              class="d-flex flex-column align-center justify-center shaft-image"
            >
              <router-link
                router-link
                :to="`/schacht/${currentShaft.id}/aufbau`"
                v-if="currentShaft.cover"
              >
                <ShaftImageBuildup :shaft="currentShaft" height="350px" />
              </router-link>
              <h4 v-else>Kein Schachtaufbau</h4>
            </div>
            <v-card-actions class="grey lighten-3">
              <v-btn
                text
                :to="`/schacht/${currentShaft.id}/aufbau`"
                :disabled="!hasBase"
              >
                <v-icon color="primary" class="mr-2">{{
                  shaftBuildupEditIcon
                }}</v-icon>
                {{ shaftBuildupEditLabel }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                icon
                :disabled="!hasBuildup || currentShaft.ordered"
                @click="onResetShaftBuildupClicked(currentShaft)"
              >
                <v-icon> mdi-delete</v-icon>
              </v-btn>
              <DialogConfirm
                ref="deleteBuildupDialog"
                caption="Schachtaufbau wirklich"
                title="löschen?"
                message="Diese Aktion kann nicht mehr rückgängig gemacht werden."
                ok="Ja, löschen"
                cancel="Nein"
              />
            </v-card-actions>
          </v-card>
          <v-container
            class="mt-4 d-flex flex-column align-center justify-center"
          >
            <v-row class="ma-0 pa-0">
              <v-col
                class="d-flex flex-column justify-center align-center"
                cols="12"
              >
                <v-btn
                  depressed
                  color="primary"
                  outlined
                  width="200"
                  v-if="!currentShaft.ordered"
                  :disabled="!canSubmit"
                  @click="onOrderShaftClicked"
                  :loading="isOrdering"
                >
                  <v-icon left> mdi-cart-arrow-down</v-icon>
                  Schacht bestellen
                </v-btn>
                <p class="ma-2" v-if="currentShaft.ordered">
                  <v-icon class="mr-1">
                    mdi-cart-check
                  </v-icon>
                  Bestellt am {{ orderDate }}
                </p>
                <router-link
                  :to="`/baustellen/` + currentShaft.site_id.id"
                  depressed
                  color="primary"
                  outlined
                  width="200"
                  class="mt-4"
                >
                  zur Baustellenübersicht
                </router-link>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
      <DialogOrderConfirm
        ref="orderDialog"
        :shaft="currentShaft"
        caption="Schacht verbindlich"
        title="bestellen?"
        message="Ihre Konfiguration ist vollständig und wird zur Auftragserfassung weitergegeben."
        ok="Ja, bestellen"
        cancel="Abbrechen"
      />
    </v-container>
    <v-container v-else>
      <h4 class="text-center mt-4">
        Schacht nicht (mehr) vorhanden oder kein Zugriff. Bitte versuchen Sie es
        später erneut.
      </h4>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ShaftListItem from '@/components/ShaftListItem.vue';
import ShaftImage from '@/components/ShaftImage.vue';
import ShaftImageBuildup from '@/components/ShaftImageBuildup.vue';
import DialogConfirm from '@/components/DialogConfirm.vue';
import { formatDate } from '@/utils/utils';
import DialogOrderConfirm from '@/components/DialogOrderConfirm.vue';

export default {
  name: 'Shaft',
  components: {
    DialogOrderConfirm,
    ShaftListItem,
    ShaftImage,
    ShaftImageBuildup,
    DialogConfirm,
  },
  data: () => ({
    tab: 0,
    draw: undefined,
    isOrdering: false,
    breadcrumbItems: [
      {
        text: 'Home',
        disabled: false,
        to: '/',
      },
      {
        text: 'Baustellen',
        disabled: false,
        to: '/baustellen',
      },
      {
        text: 'Baustelle',
        disabled: false,
        to: '/baustellen/',
      },
      {
        text: 'Schacht',
        disabled: true,
      },
    ],
  }),
  computed: {
    ...mapGetters([
      'isBack',
      'lastShaftTab',
      'isLoggedIn',
      'user',
      'sites',
      'currentShaft',
    ]),
    canSubmit() {
      return (
        this.currentShaft &&
        this.currentShaft.input_channel &&
        this.currentShaft.input_channel.diameter &&
        this.currentShaft.output_channel &&
        this.currentShaft.output_channel.diameter
      );
    },
    orderDate() {
      if (!this.currentShaft || !this.currentShaft.ordered) return '';
      return formatDate(this.currentShaft.order_date);
    },
    hasBase() {
      if (!this.currentShaft) return false;
      else if (!this.currentShaft || !this.currentShaft.type) return false;
      return true;
    },
    hasBuildup() {
      if (!this.currentShaft) return false;
      else if (!this.currentShaft.top_edge || this.currentShaft.top_edge === 0)
        return false;
      return true;
    },
    shaftBaseEditLabel() {
      if (!this.currentShaft) return '';
      else if (this.currentShaft.ordered) return 'anzeigen';
      else if (!this.currentShaft || !this.currentShaft.type)
        return 'hinzufügen';
      return 'bearbeiten';
    },
    shaftBuildupEditLabel() {
      if (!this.currentShaft) return '';
      else if (this.currentShaft.ordered) return 'anzeigen';
      else if (!this.currentShaft.top_edge || this.currentShaft.top_edge === 0)
        return 'hinzufügen';
      return 'bearbeiten';
    },
    shaftBaseEditIcon() {
      if (!this.currentShaft) return '';
      else if (this.currentShaft.ordered) return 'mdi-eye';
      else if (
        !this.currentShaft ||
        !this.currentShaft.type ||
        this.currentShaft.ordered
      )
        return 'mdi-plus';
      return 'mdi-pencil';
    },
    shaftBuildupEditIcon() {
      if (!this.currentShaft) return '';
      else if (this.currentShaft.ordered) return 'mdi-eye';
      else if (
        !this.currentShaft.top_edge ||
        this.currentShaft.top_edge === 0 ||
        this.currentShaft.ordered
      )
        return 'mdi-plus';
      return 'mdi-pencil';
    },
  },
  async created() {
    if (this.currentShaft) this.setLoading(false);
    await this.autoLogin();
    if (!this.currentShaft) {
      await this.getCurrentShaft(this.$route.params.id);
    }
    if (this.isBack) {
      this.tab = this.lastShaftTab;
    }
    if (this.currentShaft) {
      this.breadcrumbItems[2].text = this.currentShaft.site_id.name;
      this.breadcrumbItems[2].to += this.currentShaft.site_id.id;
      this.breadcrumbItems[3].text = this.currentShaft.title;
    }
    this.setLoading(false);
    //console.log(this.currentShaft);
  },
  methods: {
    ...mapActions([
      'setLoading',
      'autoLogin',
      'getUser',
      'getCurrentShaft',
      'deleteShaft',
      'resetShaftBase',
      'resetShaftBuildup',
      'orderShafts',
      'setLastShaftTab',
    ]),
    onDuplicateClicked() {
      this.$router.push(
        '/schacht/add?shaft=' +
          this.currentShaft.id +
          '&site=' +
          this.currentShaft.site_id.id,
      );
    },
    async onDeleteClicked() {
      await this.deleteShaft(this.currentShaft);
      this.$router.push('/');
    },
    async onResetShaftBaseClicked(shaft) {
      var result = await this.$refs.deleteBaseDialog.show();
      if (result) {
        await this.resetShaftBase(shaft);
      }
    },
    async onResetShaftBuildupClicked(shaft) {
      var result = await this.$refs.deleteBuildupDialog.show();
      if (result) {
        await this.resetShaftBuildup(shaft);
      }
    },
    async onOrderShaftClicked() {
      var result = await this.$refs.orderDialog.show();
      if (result) {
        this.isOrdering = true;
        await this.orderShafts({
          shafts: [this.currentShaft],
          deliveryDate: result,
        });
        this.isOrdering = false;
      }
    },
    onTabChange(tab) {
      this.setLastShaftTab(tab);
      if (tab === 0) this.$refs.shaftImage.redraw();
    },
  },
};
</script>

<style scoped>
.shaft-tabs >>> .v-tabs-bar__content {
  border-radius: 4px !important;
  border: 1px solid var(--v-primary-base) !important;
}

.shaft-tabs >>> .v-tab--active {
  color: white;
  background: var(--v-primary-base);
  margin-top: -1px;
  margin-left: -1px;
  height: 105%;
  border-radius: 4px;
}

.shaft-tabs >>> .v-tabs-slider {
  display: none;
}

.shaft-tabs >>> .v-tab:not(.v-tab--active) {
  color: var(--v-primary-base) !important;
}

.subtitle {
  color: rgba(0, 0, 0, 0.6);
}

.shaft-image {
  height: 400px;
}
</style>
